<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Start Table -->
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_length" id="datatable_length">
                    <label
                      >Show
                      <select
                        name="datatable_length"
                        aria-controls="datatable"
                        v-model="perPage"
                        class="
                          custom-select custom-select-sm
                          form-control
                          form-control-sm
                          form-select
                          form-select-sm
                        "
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      entries</label
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="datatable_filter" class="dataTables_filter">
                    <label
                      >Search:<input
                        type="search"
                        class="form-control form-control-sm"
                        placeholder=""
                        aria-controls="datatable"
                        v-model.trim="search"
                    /></label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <b-table
                    class="
                      table
                      mt-2
                      dt-responsive
                      nowrap
                      w-100
                      dataTable
                      no-footer
                      dtr-inline
                    "
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :fields="column"
                    id="datatable"
                    :items="items"
                    :per-page="perPage"
                    :busy="loading"
                    show-empty
                    @sort-changed="sortChanged"
                  >
                    <template #cell(full_address_street)="data">
                      <router-link
                        :to="
                          '/mpg/addresses/' + data.item.address_id + '/details'
                        "
                      >
                        {{ data.value }}
                      </router-link>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle mr-2"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row" v-if="rows > 0">
                <div class="col-sm-12 col-md-5">
                  <div
                    class="dataTables_info"
                    id="datatable_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{
                      currentPage * perPage > rows
                        ? rows
                        : currentPage * perPage
                    }}
                    of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <div
                    class="dataTables_paginate paging_simple_numbers"
                    id="datatable_paginate"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                      v-on:change="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    type="button"
                    @click="$router.push({ path: '/mpg/addresses/create' })"
                    class="btn btn-success waves-effect waves-light"
                  >
                    Create Address
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Card Body -->
        </div>
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { addressesService } from '../services/addresses.service'
import { debounce } from '../helpers'
import moment from 'moment'

export default {
  name: 'Addresses',
  components: {},
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      items: [],
      count: 0,
      search: '',
      column: [
        {
          key: 'full_address_street',
          sortable: true,
          label: 'Full Address',
          class: 'sorting',
          formatter (value, node, data) {
            return (
              data.address_street +
              ', ' +
              data.state.name +
              ', ' +
              data.city +
              ', ' +
              data.zip_code
            )
          }
        },
        {
          key: 'address_street',
          sortable: true,
          label: 'Address Street',
          class: 'sorting'
        },
        {
          key: 'city',
          sortable: true,
          label: 'City',
          class: 'sorting'
        },
        {
          key: 'state.name',
          sortable: true,
          label: 'State',
          class: 'sorting'
        },
        {
          key: 'zip_code',
          sortable: true,
          label: 'ZIP Code',
          class: 'sorting'
        },
        {
          key: 'organizations_addresses',
          sortable: true,
          label: 'Current Organizations',
          class: 'sorting',
          formatter (value) {
            const result = []
            if (value) {
              value.forEach((org) => {
                if (org.property_status === 'active') {
                  result.push(org.organization.name)
                }
              })
            }
            return result.join(', ')
          }
        }
      ],
      sortBy: 'full_address_street',
      sortDesc: false,
      tagList: [],
      loading: true
    }
  },
  computed: {
    rows () {
      return this.count
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    search: debounce(function (newVal) {
      this.loadData()
    }, 500),
    perPage (newVal) {
      this.loadData()
    },
    sortBy (newVal) {
      this.loadData()
    },
    sortDesc (newVal) {
      this.loadData()
    }
  },
  methods: {
    moment,
    loadData () {
      this.loading = true
      let sort = this.sortBy
      if (this.sortBy === 'full_address_street') {
        sort = 'address_street'
      }
      addressesService
        .getData({
          q: 'q=' + this.search,
          ordering: this.sortDesc ? '-' + sort : sort,
          limit: this.perPage,
          offset: (this.currentPage - 1) * this.perPage
        })
        .then((rs) => {
          this.items = rs.results
          this.loading = false
          this.count = rs.count
        })
    },
    sortChanged (e) {
      this.sortDesc = e.sortDesc
      this.sortBy = e.sortBy
    },
    onPageChange (value) {
      this.currentPage = value
      this.loadData()
    },
    onSubmit () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Addresses.vue